import React from 'react';
import './MissingPage.scss';
import Hero from "../../common/Hero/Hero";
import {useTranslation} from "react-i18next";

const MissingPage = () => {
  const {t} = useTranslation();
  return (
    <div className="MissingPage" data-testid="MissingPage">
      <Hero backTo={'/'}
            backToText={t("common.back.home")}
            title={t("common.back.title")}
      />

      <div className="container">
        <div className="row">
          <div className="col">
            {t("common.missingPage.content")}
          </div>
        </div>
      </div>
    </div>
  )
};

MissingPage.propTypes = {};

export default MissingPage;
